import { render, staticRenderFns } from "./StandardNavigation.vue?vue&type=template&id=89bc5b60"
import script from "./StandardNavigation.vue?vue&type=script&lang=ts"
export * from "./StandardNavigation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports